import { FallBackImage } from './fallbackImage';

export const AvatarUriLoad = (reply) => {
  if (reply?.author?.picture && reply?.author?.picture != 'google.com')
    return reply?.author?.picture;
  else return FallBackImage;
};
